module.exports = __webpack_public_path__ + "img/apostilas2.2b7bde1f.jpg";